import TextField from '@mui/material/TextField';
import Autocomplete from '@mui/material/Autocomplete';
import countryData from "./Country_Risk_Data_2024.json";

export default function AutoComplete({ options, fieldName, onChange }) {

  //Autocomplete uses key "label" from options array by default, so we use getOptionLabel & isOptionEqualToValue
  //In this way, we use key "Country" or "Industry" or anything we want as a list
  return (
    <Autocomplete
      disablePortal
      disableClearable
      options={options}
      getOptionLabel={(option) => option[fieldName]}
      isOptionEqualToValue={(option, value) => option[fieldName] === value[fieldName]}
      onChange={(event, value) => onChange(value)}    //send selected object from options array
      sx={{ m: 1, minWidth: 190 }}
      renderInput={(params) => <TextField {...params} label={`Select ${fieldName}`} />}
    />
  );
}